import { daysFromToday, endOfDay } from 'utils/dateHelper';
import { fillObject, unflattenAssign } from 'utilities';
import { LOCATION_CHANGE } from 'react-router-redux';
import {
  UPDATE_FIELDS,
  RESET_FIELDS,
  POPULATE_FIELDS,
  LOAD_AD,
} from 'actions/editable-ad';

import {
  ALL_GENDERS_VALUE,
  FREE_TRIAL_NULL_VALUE,
  UPLOADED_AUDIO,
  UPLOADED_COVER_ART,
  DEFAULT_AUDIO,
  EXISTING_VOICEOVER,
  NEW_VOICEOVER,
  BG_MUSIC,
  EXISTING_VO_BG_MUSIC,
  PLATFORMS,
} from 'config';

import {
  createDefaultAudioUploadObj,
  createDefaultImageUploadObj,
} from 'config/uploadProperties';

export const initialFieldsState = {
  name: '',
  clickthroughUrl: '',
  internalName: '',
  objective: '',
  uploads: {
    [UPLOADED_COVER_ART]: createDefaultImageUploadObj(),
    [UPLOADED_AUDIO]: createDefaultAudioUploadObj(),
    [BG_MUSIC]: createDefaultAudioUploadObj(),
    [EXISTING_VO_BG_MUSIC]: createDefaultAudioUploadObj(),
  },
  audioSubmission: {
    active: DEFAULT_AUDIO,
    [EXISTING_VOICEOVER]: {
      data: {
        id: '',
        uri: '',
        name: '',
      },
      bgMusic: {},
    },
    [NEW_VOICEOVER]: {
      name: '',
      transcript: '',
      instructions: '',
      locale: '',
      voice: '',
      bgMusic: {},
    },
  },
  targeting: {
    locations: [],
    platforms: fillObject(Object.keys(PLATFORMS), true),
    gender: ALL_GENDERS_VALUE,
    ageRange: {
      start: '13',
      end: '65',
    },
    fanAudiences: [],
    moments: [],
    genres: [],
    freeTrial: FREE_TRIAL_NULL_VALUE,
  },
  dateRange: {
    begin: daysFromToday(2),
    end: endOfDay(daysFromToday(2)),
  },
  payments: {},
  activeStep: parseInt(window.location.pathname.split('/')[2], 10) || 1,
};

function populateFields(state, action) {
  return {
    ...state,
    ...action.state,
  };
}

export default function fields(state = initialFieldsState, action) {
  let newState;

  switch (action.type) {
    case UPDATE_FIELDS:
      return unflattenAssign(action.field.key, action.field.value, state);
    case RESET_FIELDS:
      return {
        ...state,
        ...initialFieldsState,
      };
    case POPULATE_FIELDS:
      return populateFields(state, action);
    case LOCATION_CHANGE:
      return {
        ...state,
        activeStep: parseInt(action.payload.pathname.split('/')[2], 10) || 1,
      };
    case LOAD_AD: {
      newState = {
        ...state,
        ...action.payload,
      };

      const { begin, end } = newState.dateRange;

      newState.dateRange.begin = new Date(begin);
      newState.dateRange.end = new Date(end);

      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adCreation.js